import React, { useState } from 'react';
import { Input, Button, Typography, Space, Alert, message, Carousel } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { MailOutlined, LockOutlined, CloudOutlined, SyncOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { useAuth } from '../../aws/AuthContext';
import './styleCrearUser.css'; // Usamos exactamente tus mismos estilos

const { Text } = Typography;

const RecuperarPassword = () => {
    const navigate = useNavigate();
    const { solicitarRecuperacion, confirmarNuevaClave } = useAuth();
    
    const [paso, setPaso] = useState(1);
    const [loading, setLoading] = useState(false);
    
    const [correo, setCorreo] = useState('');
    const [codigo, setCodigo] = useState('');
    const [nuevaClave, setNuevaClave] = useState('');
    
    const [errorMsg, setErrorMsg] = useState(null);

    const handleSolicitarCodigo = async () => {
        setErrorMsg(null);
        if (!correo) {
            setErrorMsg("Por favor, ingresa tu correo electrónico registrado.");
            return;
        }
        
        setLoading(true);
        try {
            await solicitarRecuperacion(correo);
            setPaso(2);
        } catch (error) {
            if (error.code === 'UserNotFoundException') {
                setErrorMsg("No encontramos ninguna cuenta con ese correo.");
            } else {
                setErrorMsg(error.message || "Error al solicitar la recuperación.");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleActualizarClave = async () => {
        setErrorMsg(null);
        if (!codigo || !nuevaClave) {
            setErrorMsg("Por favor, llena todos los campos.");
            return;
        }
        if (nuevaClave.length < 8) {
            setErrorMsg("La contraseña debe tener mínimo 8 caracteres.");
            return;
        }
        
        setLoading(true);
        try {
            await confirmarNuevaClave(correo, codigo, nuevaClave);
            message.success("¡Tu contraseña ha sido actualizada con éxito!");
            navigate('/login');
        } catch (error) {
            if (error.code === 'CodeMismatchException') {
                setErrorMsg("El código ingresado es incorrecto.");
            } else if (error.code === 'ExpiredCodeException') {
                setErrorMsg("El código expiró. Vuelve al inicio para solicitar uno nuevo.");
            } else {
                setErrorMsg(error.message || "Error al cambiar la contraseña.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="register-wrapper">
            <div className="register-ad-column">
                <Carousel autoplay effect="fade" autoplaySpeed={5000}>
                    <div className="reg-ad-slide slide-reg-1">
                        <div className="reg-ad-overlay">
                            <CloudOutlined className="reg-ad-icon" />
                            <h2>Seguridad Integral</h2>
                            <p>Tus datos siempre protegidos bajo los más altos estándares de seguridad en la nube.</p>
                        </div>
                    </div>
                    <div className="reg-ad-slide slide-reg-2">
                        <div className="reg-ad-overlay">
                            <SyncOutlined className="reg-ad-icon" />
                            <h2>Control Total</h2>
                            <p>Gestiona los accesos de tu equipo en cualquier momento y desde cualquier lugar.</p>
                        </div>
                    </div>
                    <div className="reg-ad-slide slide-reg-3">
                        <div className="reg-ad-overlay">
                            <ThunderboltOutlined className="reg-ad-icon" />
                            <h2>Rápido y Seguro</h2>
                            <p>Optimiza tus procesos diarios con una interfaz diseñada para la velocidad.</p>
                        </div>
                    </div>
                </Carousel>
            </div>

            <div className="register-form-column">
                <div className="register-box">
                    <div className="register-header">
                        <a href='/'>
                            <img src="/img/g1.png" alt="Yugonub Logo" style={{ width: "340px", height: "58px", maxWidth: "100%", objectFit: "contain" }} />
                        </a>
                        <Text type="secondary" style={{ marginTop: '15px', display: 'block', fontSize: '15px' }}>
                            {paso === 1 ? "Recuperación de cuenta" : "Crea tu nueva contraseña"}
                        </Text>
                    </div>

                    <div className="inputs-area fade-in">
                        {errorMsg && (
                            <Alert message="Atención" description={errorMsg} type="error" showIcon style={{ marginBottom: '20px', borderRadius: '8px' }} />
                        )}

                        {paso === 1 ? (
                            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                                <div>
                                    <Text strong style={{ display: 'block', marginBottom: '8px' }}>Ingresa tu correo electrónico</Text>
                                    <Input 
                                        size="large" 
                                        prefix={<MailOutlined style={{ color: '#22BABB' }} />} 
                                        placeholder="usuario@ejemplo.com" 
                                        value={correo} 
                                        onChange={e => setCorreo(e.target.value)} 
                                        onPressEnter={handleSolicitarCodigo}
                                    />
                                    <Text type="secondary" style={{ fontSize: '12px', display: 'block', marginTop: '5px' }}>
                                        Te enviaremos un código de seguridad para verificar tu identidad.
                                    </Text>
                                </div>

                                <Button type="primary" block className="btn-yugonub-reg" onClick={handleSolicitarCodigo} loading={loading} style={{ marginTop: '10px' }}>
                                    ENVIAR CÓDIGO
                                </Button>
                                
                                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                                    <Button type="link" onClick={() => navigate('/login')} style={{ color: '#747F8E' }}>
                                        Cancelar y volver
                                    </Button>
                                </div>
                            </Space>
                        ) : (
                            <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                                <Alert 
                                    message="Revisa tu bandeja de entrada" 
                                    description={`Enviamos un código de seguridad a ${correo}.`} 
                                    type="info" 
                                    showIcon 
                                    style={{ marginBottom: '10px', borderRadius: '8px' }} 
                                />

                                <div>
                                    <Text strong style={{ display: 'block', marginBottom: '8px' }}>Código de 6 dígitos</Text>
                                    <Input 
                                        size="large" 
                                        placeholder="Ingresa el código" 
                                        value={codigo} 
                                        maxLength={6}
                                        onChange={e => setCodigo(e.target.value.replace(/\D/g, ''))} // Solo números
                                    />
                                </div>

                                <div>
                                    <Text strong style={{ display: 'block', marginBottom: '8px' }}>Nueva contraseña</Text>
                                    <Input.Password 
                                        size="large" 
                                        prefix={<LockOutlined style={{ color: '#22BABB' }} />} 
                                        placeholder="Crea una contraseña segura" 
                                        value={nuevaClave} 
                                        onChange={e => setNuevaClave(e.target.value)} 
                                        onPressEnter={handleActualizarClave}
                                    />
                                    <Text type="secondary" style={{ fontSize: '11px', display: 'block', marginTop: '4px' }}>
                                        Mínimo 8 caracteres, incluye mayúscula, número y un símbolo especial.
                                    </Text>
                                </div>

                                <Button type="primary" block className="btn-yugonub-reg" onClick={handleActualizarClave} loading={loading} style={{ marginTop: '10px' }}>
                                    ACTUALIZAR CONTRASEÑA
                                </Button>

                                <div style={{ textAlign: 'center', marginTop: '15px' }}>
                                    <Button type="link" onClick={() => { setPaso(1); setCodigo(""); setErrorMsg(null); }} style={{ color: '#747F8E' }}>
                                        ¿No recibiste el código? Solicitar de nuevo
                                    </Button>
                                </div>
                            </Space>
                        )}
                    </div>
                </div>

                <div className="register-legal-fixed">
                    <div className="legal-container">
                        <Link style={{ color: '#747F8E', fontWeight: '500' }} to="/terminos-y-condiciones">Términos y Condiciones</Link>
                        <span className="legal-sep text-gray-300">|</span>
                        <Link style={{ color: '#747F8E', fontWeight: '500' }} to="/politica-privacidad">Política de Privacidad</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecuperarPassword;